import { render, staticRenderFns } from "./WBtnIconHelp.vue?vue&type=template&id=9365f8b8&scoped=true&"
import script from "./WBtnIconHelp.vue?vue&type=script&lang=js&"
export * from "./WBtnIconHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9365f8b8",
  null
  
)

export default component.exports